import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

import index from '@/views/index'
import pop from '@/views/pop'

const routerules = [
    {
        path: '/pop',
        component: pop
    },
    {
        path: '/pop/:sub',
        component: pop
    },
    {
        path: '/pop/:sub/:id(\\d+)',
        component: pop
    },
    {
        path: '/',
        component: index
    },
    {
        path: '/:root',
        component: index
    },
    {
        path: '/:root/:id(\\d+)',
        component: index
    },
    {
        path: '/:root/:id(\\d+)/:subid(\\d+)',
        component: index
    },
    {
        path: '/:root/:sub',
        component: index
    },
    {
        path: '/:root/:sub/:id(\\d+)',
        component: index
    },
    {
        path: '/:root/:sub/:id(\\d+)/:subid(\\d+)',
        component: index
    },
    {
        path: '/:root/:sub/:par',
        component: index
    }
];

const router = new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: routerules
});

export default router;

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
